import { createAsyncThunk } from "@reduxjs/toolkit"
import { getFeedStats } from "@/entities/feed/api/fetchStats"
import { getFilterInputs } from "../lib/helpers/getFiltersInputs"

export const fetchFilters = createAsyncThunk("filter/fetchInputs", async () => {
	const stats = await getFeedStats()
	if (!stats) return { inputs: [], total: 0 }

	const inputs = getFilterInputs(
		stats.roomsSet ?? null,
		stats.minPrice && stats.maxPrice
			? [Math.round(stats.minPrice), Math.round(stats.maxPrice)]
			: null,
		stats.minSquare && stats.maxSquare
			? [Math.round(stats.minSquare), Math.round(stats.maxSquare)]
			: null
	)

	return { inputs, total: stats.total }
})
